<template>
  <Selector
    v-if="selectionEnabled"
    :selected-option="selectedFilterLogic"
    :options="filterLogicOptions"
    @select="$emit('select-logic', $event)"
  />

  <SelectionDisplay v-else :text="selectedFilterLogic.label" />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { FilterListLogic, LogicOption } from '@/filter/types';

import SelectionDisplay from './SelectionDisplay.vue';
import Selector from './Selector.vue';

export default defineComponent({
  name: 'LogicSelector',
  emits: { 'select-logic': null },

  components: {
    SelectionDisplay,
    Selector,
  },

  props: {
    logic: {
      type: String as PropType<FilterListLogic>,
      required: true,
    },

    selectionEnabled: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      filterLogicOptions: (() => {
        const options: Array<LogicOption> = [
          { value: 'all', label: this.$t('filter.and') },
          { value: 'any', label: this.$t('filter.or') },
        ];

        return options;
      })(),
    };
  },

  computed: {
    selectedFilterLogic(): LogicOption {
      return { value: this.logic, label: this.$t(this.logic === 'all' ? 'filter.and' : 'filter.or') };
    },
  },
});
</script>
